<template>
  <transition name="confirm-fade">
    <div v-if="isShowConfirm" class="my-confirm" @click.stop="clickFun('clickCancel')">
      <div :class="['wrap', { 'container-dark': theme_dark }]" @click.stop>
        <h3 class="title"> <img src="../assets/img/提醒.png" class="warning-img" />{{ titleText }}</h3>
        <div class="content" v-html="content"></div>
        <div class="oper ub">
          <div class="ok ub ub-ac ub-pc" @click="clickFun()">
            <span>{{ timeout }}<label v-if="timeout >= 0">秒后可关闭！</label></span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script >
import * as tool from '../api/common';
export default {
  data() {
    return {
      isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
      titleText: "操作提示", // 提示框标题
      content: "Say Something ...", // 提示框的内容
      confirmText: "确认", // 确认按钮的文字
      outerData: null, // 用于记录外部传进来的数据，也可以给外部监听userBehavior，事件的函数提供判断到底是哪个事件触发的
      timeout: 10,
      canClick: true,
      theme_dark: false
    };
  },
  methods: {
    show(content, config) {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.content = content || "Say Something ...";
      if (Object.prototype.toString.call(config) === "[object Object]") {
        // 确保用户传递的是一个对象
        this.titleText = config.titleText || "操作提示";
        this.cancelText = config.cancelText || "取消";
        this.confirmText = config.confirmText || "确认";
        this.outerData = config.data || null;
        this.timeout=config.timeout;
      }

       this.isShowConfirm = true;
       this.time();
    },
    time() {
        let clock = window.setInterval(() => {
        this.timeout--;
        if (this.timeout < 0) {
          window.clearInterval(clock);
          this.timeout = "我知道错了";
        }
      }, 1000);
    },
    hidden() {
      this.isShowConfirm = false;
      this.titleText = "操作提示";
      this.confirmText = "确认";
      this.outerData = null;
    },
    clickFun() {
        if(this.timeout>0){
            return false;
        }
        this.$emit("formBehavior", this.outerData);
        this.hidden();
    },
  },
};
</script>

<style lang="scss" scoped>
.my-confirm {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

/* 进入和出去的动画 */
.confirm-fade-enter-active {
  animation: opacity 0.3s;
}

.confirm-fade-leave-active {
  animation: outOpacity 0.2s;
}

/* 进来的动画 */
@keyframes opacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

/* 出去的动画 */
@keyframes outOpacity {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

/* 包裹层容器样式 */
.wrap {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        width: 85%;
        margin: 0 auto;
        z-index: 999;
        user-select: none;
        border-radius: 1rem;
        background: linear-gradient(to bottom, #FE9CC0, #fff 3rem);
}

/* 顶部标题部分 */
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0.8rem 0;
  text-align: center;
  font-size: 1.2rem; font-weight: 600;
  color: #f14950;
  .warning-img {
    width: 1.3rem;
    height: 1.1rem;
    margin-right: .3rem;
  }
}

/* 中间内容部分 */
.content {
  min-height: 5rem;
  padding: 0 1rem;
  text-align: left;
  font-size: 0.9rem;
  color: #888;
  line-height: 1.6rem;
}

/* 底部按钮样式 */
.oper {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  .ok {
    flex: 1;
    margin: 0 0.5rem;
    border-radius: 2rem;
    background: linear-gradient( 90deg, #A264E7, #FE9CC0);
    span {
        line-height: 2.6rem;
        color: #fff;
      }
  }
}


.container-dark {
  background: linear-gradient(to bottom, #9c365c, #333 3rem);
}

</style>